var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10c0-2.828 0-4.243.879-5.121C6.257 4 7.672 4 10.5 4h3c2.828 0 4.243 0 5.121.879.879.878.879 2.293.879 5.121v5c0 2.828 0 4.243-.879 5.121C17.743 21 16.328 21 13.5 21h-3c-2.828 0-4.243 0-5.121-.879C4.5 19.243 4.5 17.828 4.5 15v-5z",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18a3 3 0 01-3-3V9c0-3.771 0-5.657 1.172-6.828C3.843 1 5.729 1 9.5 1h4a3 3 0 013 3",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })));
}

export default SvgCopyThin;